import { ReactNode } from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import {
  BackgroundColorProps,
  background,
  BorderColorProps,
  borderColor,
  ColorProps,
  color,
} from "styled-system";

import Typography from "../Typography/Typography";

interface StepLabelProps {
  index: number;
  minContainerWidth: number;
  numberOfItems: number;
  labelsColor: ColorProps["color"];
  labelsBackgroundColor: BackgroundColorProps["backgroundColor"];
  labelsBorderColor: BorderColorProps["borderColor"];
  children: ReactNode;
}

const Label = styled(Typography)<
  BorderColorProps &
    BackgroundColorProps & {
      isFirst: boolean;
      isLast: boolean;
      minContainerWidth: number;
    }
>`
  min-width: 28px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  ${css({
    mb: 2,
    borderWidth: "border-size-thick",
    borderStyle: "solid",
    fontWeight: "bold",
    fontSize: "h6",
  })}

  ${(props) =>
    css({
      [`@media only screen and (min-width: ${props.minContainerWidth}px)`]: {
        position: "relative",
        mb: 0,
        marginLeft: props.isFirst ? "calc(50% - 14px)" : "12px;",
        marginRight: props.isLast ? "calc(50% - 14px)" : "12px;",
      },
    })}
  ${borderColor}
  ${background}
  ${color}
`;

const StepLabel = ({
  index,
  minContainerWidth,
  numberOfItems,
  labelsColor,
  labelsBackgroundColor,
  labelsBorderColor,
  children,
}: StepLabelProps) => (
  <Label
    htmlTag="span"
    isFirst={index === 0}
    isLast={index === numberOfItems}
    minContainerWidth={minContainerWidth}
    borderColor={labelsBorderColor}
    color={labelsColor}
    backgroundColor={labelsBackgroundColor}
  >
    {children}
  </Label>
);

export default StepLabel;
